/**
 * Determines if a weight is too low for a given height.
 * @param weightKg - Weight in kilograms
 * @param heightCm - Height in centimeters
 * @returns true if BMI < 18.5, false otherwise
 */
export const isWeightTooLowBMI = (
    weightKg: number,
    heightCm: number,
): boolean => {
    const heightM = heightCm / 100; // convert cm to meters
    const bmi = weightKg / (heightM * heightM);
    return bmi < 18.5;
};
